export default {
    path: "/profile",
    name: "profile",
    children: [
        {
            path: "",
            name: "profile",
            component: () => import('@/views/Profile/Index.vue')
        },
        {
            path: "personality-map",
            name: "personalityMap",
            component: () => import('@/views/Profile/PersonalityMap/Index.vue')
        }
    ]
}